import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';
import Lozenge from '@atlaskit/lozenge';
import { Frame } from '../components/Frame';
import { Thumbnail } from '../components/Thumbnail';
import { Provider } from '../components/Provider';
import { Name } from '../components/Name';
import { Byline } from '../../common/Byline';
import { ActionList } from '../components/ActionList';
import { CollaboratorList } from '../components/CollaboratorList';
import { Emoji } from '../components/Emoji';
import { Icon } from '../../common/Icon';
import { Content } from '../components/Content';
import { MetadataList } from '../../common/MetadataList';
import { LozengeBlockWrapper } from './styled';
import { ContentHeader } from '../components/ContentHeader';
import { ContentFooter } from '../components/ContentFooter';
import { gs } from '../../common/utils';
import { handleClickCommon } from '../utils/handlers';
const styles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start'
});
/**
 * Class name for selecting non-flexible resolved block card
 *
 * @deprecated {@link https://hello.jira.atlassian.cloud/browse/ENGHEALTH-6878 Internal documentation for deprecation (no external access)}
 * Using this selctor is deprecated as once the flexible block card feature flag is removed, this class will no longer be used.
 */
export const blockCardResolvedViewClassName = 'block-card-resolved-view';
/**
 * Class name for selecting non-flexible resolved byline
 *
 * @deprecated {@link https://hello.jira.atlassian.cloud/browse/ENGHEALTH-6878 Internal documentation for deprecation (no external access)}
 * Using this selctor is deprecated as once the flexible block card feature flag is removed, this class will no longer be used.
 */
export const blockCardResolvedViewByClassName = 'block-card-resolved-view-by';
export const ResolvedView = ({
  icon = {},
  actions = [],
  thumbnail,
  context = {
    text: ''
  },
  title = '',
  titleTextColor,
  titlePrefix,
  isSelected = false,
  users = [],
  handleAvatarClick = () => {},
  handleMoreAvatarsClick = () => {},
  onClick = () => {},
  link = '',
  byline = '',
  lozenge,
  details = [],
  testId = 'block-card-resolved-view'
}) => {
  const resolvedMetadata = details.length > 0 ? jsx(MetadataList, {
    testId: testId ? `${testId}-meta` : undefined,
    items: details
  }) : undefined;
  const resolvedByline = jsx(Byline, {
    testId: testId ? `${testId}-by` : undefined
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: blockCardResolvedViewByClassName
  }, byline);
  const handleClick = event => handleClickCommon(event, onClick);
  const hasActions = actions.length > 0;
  return jsx(Frame, {
    isSelected: isSelected,
    testId: testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: blockCardResolvedViewClassName
  }, jsx(Content, null, jsx("div", null, jsx("div", {
    css: styles
  }, jsx(ContentHeader, {
    onClick: handleClick,
    link: link
  }, titlePrefix ? jsx(Emoji, {
    emoji: titlePrefix
  }) : jsx(Icon, icon), jsx(Name, {
    name: title,
    textColor: titleTextColor
  }), lozenge && jsx(LozengeBlockWrapper, {
    css: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      height: gs(2.5),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, jsx(Lozenge, _extends({
    style: lozenge.style
  }, lozenge), lozenge.text))), jsx(CollaboratorList, {
    items: users,
    handleAvatarClick: handleAvatarClick,
    handleMoreAvatarsClick: handleMoreAvatarsClick,
    testId: testId ? `${testId}-collaborator-list` : undefined
  })), resolvedByline, resolvedMetadata), jsx(ContentFooter, {
    hasSpaceBetween: hasActions
  }, jsx(Provider, {
    name: context.text,
    icon: context.icon
  }), hasActions && jsx(ActionList, {
    items: actions
  }))), thumbnail ? jsx(Thumbnail, {
    src: thumbnail,
    testId: testId ? `${testId}-thumb` : undefined
  }) : null);
};